<template>
  <div id="app" >
             <!-- <Modal v-if="modalToggle" ></Modal>   -->


             <div class="modal-GR" v-if="modalToggle">

                <div class="card">
                    <div class="card-image">	
                        <h2 class="card-heading">
                            <small>הוספת ספק חדש</small>
                        </h2>
                    </div>
                    <p v-if="errorDealer" class="error">{{ errorAddingDealer }}</p>
                    <form class="card-form">
                        <div class="input">
                            <input type="text" class="input-field" placeholder="שם הספק" v-model="selectDealerName" />
                        </div>
                        <div class="input">
                             <select v-model="type" class="input-field" >
                                    <option value="" selected>-- נא לבחור את התפקיד --</option>
                                    <option value="עובד">עובד</option>
                                    <option value="ספק">ספק</option>
                            </select>   
                            
                        </div>
                        <div class="action" @click="addDealer()">
                            אישור
                        </div>
                    </form>
                    <div class="card-info">
                        <button type="button" class="link-btn" @click="closeModal">סגור</button>
                    </div>
                </div> 
            </div>
            <div class="modal-GR" v-if="newCategoryModal">

                <div class="card">
                    <div class="card-image">	
                        <h2 class="card-heading">
                            <small>הוספת ספק חדש</small>
                        </h2>
                    </div>
                    <p v-if="errorDealer" class="error">{{ errorAddingDealer }}</p>
                    <form class="card-form">
                        <div class="input">
                            <input type="text" class="input-field" placeholder="שם הספק" v-model="selectDealerName" />
                        </div>
                        <div class="action" @click="addDealer()">
                            אישור
                        </div>
                    </form>
                    <div class="card-info">
                        <!-- <a href="#" @click="closeModal">סגור</a> -->
                        <button type="button" class="link-btn" @click="closeModal">סגור</button>

                    </div>
                </div> 

            </div>

<AddChequeModal :chequeModal="chequeModal" :Dealers="Dealers" @close="closeChequeModal"  @save="addCheque"></AddChequeModal>
                <div class="modal-GR" v-if="secretModal">
                    <div class="card">
                        <div class="card-image">	
                            <h2 class="card-heading">
                                <small>מתכון חדש</small>
                            </h2>
                        </div>
                        <p v-if="errorDealer" class="error">{{ errorAddingDealer }}</p>
                        <form class="card-form">
                            <div class="input">
                                <!-- <input type="text" class="input-field" placeholder="שם הספק" v-model="cheque.dealerName" /> -->
                                
                                <input type="text"  v-model="secret.name" class="input-field" list="exampleList" placeholder="שם המתכון">
                                    <!-- <datalist  id="exampleList">
                                        <option :value="person.Data.selectDealerName" v-for="person in Dealers" ></option>
                                    </datalist > -->
                                        
                            </div>
                            <div class="input">
                                <textarea type="text" class="input-field" placeholder='מתכון' v-model="secret.note" >
                                </textarea>
                                </div>
                            <div class="action" @click="addExpense()">
                                אישור
                            </div>
                        </form>
                        <div class="card-info">
                            <button type="button" class="link-btn" @click="closeChequeModal">סגור</button>
                        </div>
                    </div> 
                </div>
            <topHeader @open-modal="handleOpenModal" />

        <main class="main">
            <!--  /////////////     Top Bar     //////////////       -->
            <UpdateModal v-if="showUpdateModal" />



            

            <!--  //////////////                 /////////////       -->
            <div class="paths" v-if="!$route.meta.hideNavbar">

                <!-- <button data-toggle="modal" data-target="#exampleModal" >הזמנה חדשה + </button> -->
                <router-link to="/newOrderBeta" class="link">יצירת הזמנה</router-link>
                <!-- <b-button v-b-modal.modal-center>הזמנה חדשה + </b-button> -->
                
            </div>
            
            <!--  //////////////                 /////////////       -->

            <keep-alive exclude="SelectedOrderBeta,SignIn">
                <router-view></router-view>
            </keep-alive>

          <!-- <nav class="mobile-bottom-nav" v-if="!$route.meta.hideNavbar">
                <div class="menuLine">
                    <div class="menuItem">
                    <router-link to="/Home" class="button">
                        <i class="material-icons">home</i>
                        <span>דף הבית</span>
                    </router-link>	
                </div>
                <div class="menuItem">		
                        <router-link to="/ordersBeta" class="button">
                            <i class="material-icons">local_mall</i>
                            <span>הזמנות</span>
                        </router-link>
                    
                </div>
                <div class="menuItem">
                    <div class="addBox">
                    	<router-link to="/newOrderBeta" class="button">
                            <i class="material-icons">add_box</i>
                            <span>יצירת הזמנה</span>
                        </router-link>
                    </div>
                </div>
                <div class="menuItem">
                        <router-link to="/Inventory" class="button">
                            <i class="material-icons">inventory</i>
                            <span>מלאי</span>
                        </router-link>
                </div>
                
                <div class="menuItem">
                    	<button @click="toCheques" class="button">
                            <i class="material-icons">money</i>
                            <span>שיקים</span>
                        </button>
                </div>
                </div>
                    <div class="iphoneLine">

                    </div>
                
            </nav> -->
                    <BottomNavbar v-if="showNavbar && $root.loggedUser"  />

        </main>
        
        
    </div>
  
</template>

<script>
import BottomNavbar from './components/BottomNavbar.vue'
import topHeader from './components/topHeader.vue';
import Navbar from './components/Navbar';
import Modal from './components/modal';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "firebase/auth";
import { db } from '../src/firebase';
import firebase from "firebase/app";
import "firebase/messaging";
import moment from 'moment';
import { RouterLink } from 'vue-router';
import UpdateModal from "./components/UpdateModal.vue";
import AddChequeModal from './components/AddChequeModal.vue';

export default {
  
  name: 'app',
  components: {
    Navbar,
    topHeader,
    Modal,
    RouterLink,
    UpdateModal,
    BottomNavbar,
    AddChequeModal
     
},
  data () {
    return {
      siteLogo: 'Green House Cakes',
      dropOpen:false,
      addNew:false,
      modalToggle:false,
      newCategoryModal: false,
      secretModal: false,
      modalId:"",
      selectDealerName:"",
      type:'',
      Dealers:[],
    //   cheque:{
    //     dealerName:'',
    //     amount:null,
    //     formattedDate: "",
    //     createdDate: moment().format('LLLL'),
    //     checked: false,
    //   },
      cheque: {

            dealerName: '',
            amount: null,
            formattedDate: '',
            notes: '',
            createdDate: moment().format('LLLL'),
            checked: false,
        },
      secret:{
        name:'',
        note:'',
        createdDate: moment().format('LLLL'),
      },
      chequeModal: false,
      errorDealer: false,
      errorAddingDealer:"",
      isOpen:false,
      showUpdateModal: false,
      darkMode: false,
    }
  },
  created(){  
    let vm = this;
    document.addEventListener('click', this.dropdown);
    document.addEventListener('click', this.addNewDropDown); 
    vm.loadDealers();
    vm.setupVersionListener();

        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) {
            this.darkMode = savedTheme === "dark";
            document.documentElement.setAttribute("data-theme", savedTheme);
        } else {
            // اعتمادًا على إعداد الجهاز
            const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
            this.darkMode = prefersDark;
            document.documentElement.setAttribute("data-theme", prefersDark ? "dark" : "light");
        }

  },
  destroyed () {
    document.removeEventListener('click', this.dropdown);
    document.removeEventListener('click', this.addNewDropDown);

  }, 
  methods : { 
     showNavbar() {

            return ![
                '/login',
                '/register'
            ].includes(this.$route.path)

        },
        askForNotificationPermission() {
      if (!firebase.messaging.isSupported()) {
        alert("🚫 المتصفح لا يدعم الإشعارات");
        return;
      }

      const messaging = firebase.messaging();

      Notification.requestPermission().then((permission) => {
        alert("📣 النتيجة: " + permission);

        if (permission === "granted") {
          return messaging.getToken({
            vapidKey: "🔑 vapidKey تاعك من Firebase"
          });
        } else {
          alert("🛑 تم رفض الإشعارات من قبل المتصفح");
        }
      }).then((token) => {
        if (token) {
          alert("✅ تم الحصول على التوكن: " + token);
        const user = JSON.parse(localStorage.getItem("User"));
        db.collection("deviceTokens").doc(token).set({
        createdAt: new Date(),
        userID: (user && user.userID) || null,
        platform: "iOS Safari"
        });
        }
      }).catch((err) => {
        console.error("❌ Error:", err);
        alert("⚠️ خطأ أثناء الحصول على التوكن");
      });
    },
    setupVersionListener() {
      // تأكد من استيراد firebase وتهيئته في مشروعك
      db.collection("appUpdates")
        .doc("version")
        .onSnapshot((doc) => {
          if (!doc.exists) return;
          const serverVersion = doc.data().version;
          const localVersion = localStorage.getItem("appVersion") || "1.0.0";

          if (serverVersion !== localVersion) {
            localStorage.setItem("appVersion", serverVersion);
            this.showUpdateModal = true;
          }
        });
    },
    toCheques(){
        let vm = this;
        if(vm.$root.loggedUser.Type == 'Admin'){
            vm.$router.push("/Cheques");
        }else{
            // vm.$router.go(-0);
            alert("אין לך גישה לדף הזו")
        }
    },
    toCheckout(){
        let vm = this;
            vm.$router.push("/newOrderBeta");
        },
    openMenu(){
        let vm = this;
        vm.isOpen = true;

    },
    closeMenu(){
        let vm = this;
        vm.isOpen = false;
    },
    photoaid(){
        let vm = this;
        window.open("https://photoaid.com/en/tools/cropround?srsltid=AfmBOopOurCsBhhttlxL74t4uB71pQPWc7CqQRGhaEJU3co75mS-8jlI");
    },
    shutterstock(){
        let vm = this;
        window.open("https://www.shutterstock.com/create/editor");
    },
    nayax(){
        let vm = this;
        window.open("https://webui-srv.bnayax.com/");
    },
    leumi(){
        let vm = this;
        window.open("https://www.leumi.co.il/he");
    },
    uploadImage(e){
        
        if(e.target.files[0]){
                let file = e.target.files[0];
                let storageRef = firebase.storage().ref('expenses/' + file.name);
                let uploadTask = storageRef.put(file);
                uploadTask.on('state_changed', 
                (snapshot) => { 
                }, 
                (error) => {
                    // Handle unsuccessful uploads
                }, 
                () => {
                    uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                    this.expense.image.push(downloadURL);
                    // let media = { 
                    //     date: new Date().toLocaleDateString(),
                    //     image: '',
                    //     fullname: this.fullname,
                    //     orderNumber : this.counter.orderNumber
                    // }
                    // media.image = downloadURL;
                    // console.log(media);
                    // db.collection("Media").add(media);
                    console.log('File available at', downloadURL);
                    });
                }
                );

            }

            
        },
    addDealer(){
          let vm = this;
          console.log("Add ( DealerResult ) ");
          if (vm.selectDealerName.length > 0 ){
            let DealerMeheron = {
                selectDealerName: vm.selectDealerName,
                type: vm.type,
                createdDate: moment().format('LLLL')
            }
          
          db.collection("Dealers").add(DealerMeheron)
              .then(function(DealerResult){   
                  console.log("Add ( DealerResult ) Success");
                  console.log(DealerResult);
                  vm.selectDealerName = "";
              })
              .catch(function(error){
                  console.error('add( DealerResult ) Error !');
                  console.error(error);
              });
              }
              else if(vm.selectDealerName.length <= 0 ){
                vm.errorDealer = true;
                vm.errorAddingDealer = "נא למלא את השדה"
              }
      
            }, 
            loadDealers(){
          let vm = this;
          vm.Dealers = [];
          db.collection("Dealers").orderBy("createdDate","desc").get()
          .then(function(DealerMeheron){
                  for(let a = 0; a < DealerMeheron.size; a++){
                      let dealerId = DealerMeheron.docs[a].id;
                      let dealer = DealerMeheron.docs[a].data();
                    //   console.log(DealerMeheron.size);
                      vm.Dealers.push({ ID: dealerId, Data: dealer });
              }
          })
          .catch(function(error){
              console.log("Error getting document:", error);
      });
      },
addCheque(cheque) {
  db.collection('cheques')
    .add(cheque)
    .then(() => {
      if (this.$root && typeof this.$root.loadChequesSum === 'function') {
        this.$root.loadChequesSum();
      }
      this.chequeModal = false;
    })
    .catch(error => {
      console.error('Error adding cheque:', error);
      alert('לא ניתן לשמור את השיק. נסה שוב.');
    });
},
            addExpense(){
          let vm = this;
          console.log("Add ( addExpense ) ");
          if (vm.secret.name.length > 0){
            let secret = {
                name: vm.secret.name,
                note:vm.secret.note,
                createdDate: moment().format('LLLL'),
            }
          db.collection("Secrets").add(secret)
              .then(function(secretResult){   
                  console.log("Add ( secretResult ) Success");
                  console.log(secretResult);
                  vm.secret.name = "";
                  vm.secret.note = "";
              })
              .catch(function(error){
                  console.error('add( secretResult ) Error !');
                  console.error(error);
              });
            //   vm.$root.loadChequesSum();
              }
              else if(vm.secret.name.length <= 0 ){
                vm.errorDealer = true;
                vm.errorAddingDealer = "נא למלא את השדה"
              }
      
            },
    toggleOpen(){
        if (!this.dropOpen) {
		this.dropOpen = true;
        this.addNew = false;
		} else {
			this.dropOpen = false;
		}
    },
    addNewOpen(){
        if (!this.addNew) {
		this.addNew = true;
        this.dropOpen = false;
		} else {
			this.addNew = false;
		}
    },
    dropdown(e) {
  const el = this.$refs.dropdown;
  if (!el) return; // ما في ref، ما تعمل اشي
  if (el !== e.target && !el.contains(e.target)) {
    this.dropOpen = false;
  }
},
addNewDropDown(e) {
  const el = this.$refs.addNewDropDown;
  if (!el) return;
  if (el !== e.target && !el.contains(e.target)) {
    this.addNew = false;
  }
},
    logout(){
        console.log("Logout Click From App.vue");
        let vm = this;
        vm.$root.loggedUser = null;
        localStorage.removeItem("User");
        document.removeEventListener('click', vm.dropdown);
        document.removeEventListener('click', vm.addNewDropDown);
        vm.dropOpen = false;
        vm.addNew = false;
        if (this.$route.path !== "/") {
  this.$router.push("/");
}

    },
    openModal(){
        let vm = this;
        if (!vm.modalToggle) {
            vm.modalToggle = true;
		} else {
			vm.modalToggle = false;
		}

    },
    openChequeModal() {

        this.chequeModal = true

    },

    closeChequeModal() {

        this.chequeModal = false

    },
    closeModal(){
        this.modalToggle = false;
        this.errorDealer = false;
        this.errorAddingDealer = "";
        this.selectDealerName = "";
        this.type = "";
    },
    openExpenseModal(){
        let vm = this;
        if (!vm.secretModal) {
            vm.secretModal = true;
		} else {
			vm.secretModal = false;
		}
    },
    closeExpenseModal(){
        let vm = this;
        if (vm.secretModal) {
            vm.secretModal = false;
		} else {
			vm.secretModal = true;
		}
    },
    toggleTheme() {
        this.darkMode = !this.darkMode;
        const theme = this.darkMode ? "dark" : "light";
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("theme", theme);
    },
    handleOpenModal(type){
    // سكّر كل اشي قبل ما تفتح واحد
    this.modalToggle = false
    this.secretModal = false
    this.chequeModal = false
    this.newCategoryModal = false

    if(type === 'supplier') this.modalToggle = true
    if(type === 'recipe') this.secretModal = true
    if(type === 'cheque') this.chequeModal = true
  },


    
  }
}
</script>

<style >
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@100;300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Hebrew:wght@300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Oswald:wght@200;300;400;500;600;700&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@300;400;500;600;700;800;900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Alef:wght@400;700&family=Huninn&family=Playpen+Sans+Hebrew:wght@100..800&display=swap');

:root {
  --primary: #00414d;
  --primary-alt: #73e7cc;
  --grey: #64748b;
  --dark: #1e293b;
  --dark-alt: #003c47;
  --light: #f1f5f9;
  --text-color: #1e293b;
  --bg-color: #ffffff;
}

[data-theme="dark"] {
  --primary: #4dd0e1;
  --primary-alt: #263238;
  --grey: #cbd5e1;
  --dark: #f8fafc;
  --dark-alt: #607d8b;
  --light: #0f172a;
  --text-color: #ffffff;
  --bg-color: #fff;
}

html{
    padding: 0 0 77px 0;
}
#app {
    padding-bottom: 140px;
}
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Noto Sans Hebrew';
}
body {
  direction: rtl;
  background-color: var(--bg-color);
  color: var(--text-color);
}
.link{
    text-decoration: none;
    cursor: pointer;
}
.modal-GR{
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    color: var(--text-color);
    min-height: 100%;
    position: fixed;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
}
.modal-GR .modal-box{
    min-width: 450px;
    min-height: 300px;
    background-color: var(--bg-color);
color: var(--text-color);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 5px 5px -3px rgba(255,255,255,0.2), 0 8px 10px 1px rgba(255,255,255,0.14), 0 3px 14px 2px rgba(255,255,255,0.12);
}
.modal-GR .modal-box .modal-header{
    padding: 1rem;
    border-bottom: 1px solid #e0e0e0;
    background-color: var(--bg-color);
color: var(--text-color);
    font-size: 16px;
    font-weight: 700;
    font-family: 'Noto Sans Hebrew';
    color: #000;
    display: flex;
    align-items: center;
}
.card {
	margin: 2rem auto;
	display: flex;
	flex-direction: column;
	width: 100%;
	max-width: 425px;
	background-color: var(--bg-color);
color: var(--text-color);
	border-radius: 10px;
	box-shadow: 0 10px 20px 0 rgba(#999, .25);
	/* padding: .75rem; */
}

.card-image {
	border-radius: 8px;
	overflow: hidden;
	padding-bottom: 65%;
	background-image: url('https://assets.codepen.io/285131/coffee_1.jpg');
	background-repeat: no-repeat;
	background-size: 150%;
	background-position: 0 5%;
	position: relative;
}

.card-heading {
	position: absolute;
	left: 10%;
	top: 15%;
	right: 10%;
	font-size: 1.75rem;
	font-weight: 700;
	color: #735400;
	line-height: 1.222;
}

.card-form {
	padding: 2rem 1rem 0;
}
.error{
    margin: 1rem 0 0 0;
    color: red;
    background-color: var(--bg-color);
color: var(--text-color);
    border-right: 4px solid red;
    padding: 0.5rem 1rem;
}
.input  {
	display: flex;
	flex-direction: column-reverse;
	position: relative;
	padding-top: 1.5rem;
}

.input-label {
	color: #8597a3;
	position: absolute;
	top: 1.5rem;
	transition: .25s ease;
}

.input-field {
    z-index: 1;
    background-color: transparent;
    border: 1px solid #eee;
    font: inherit;
    padding: 0.5rem 1rem;
    font-family: 'Noto Sans Hebrew';
}

.action {
    margin-top: 2rem;
    background-color: #014342;
    color: var(--text-color);
    text-align: center;
    color: #fff;
    padding: 10px;
    border-radius: 5px;
    font-family: 'Noto Sans Hebrew';
}

/* .action-button {
	font: inherit;
	font-size: 1.25rem;
	padding: 1em;
	width: 100%;
	font-weight: 500;
	background-color: #6658d3;
	border-radius: 6px;
	color: #FFF;
	border: 0;
} */
.menu{
display: none;
}

.card-info {
	padding: 1rem 1rem;
	text-align: center;
	font-size: .875rem;
	color: #8597a3;

}

.hideModal{
    display: none;
}
.showModal{
    display: flex;
}
/* .is-expanded {
		width: var(--sidebar-width);
} */

.main{
    flex: 1 1 0;
    padding: 0 0 77px 0;
}
.sideBar{
    width: 100%;
    height: 70px;
    background-color: var(--bg-color);
color: var(--text-color);
    display: flex;
    align-items: center;
    justify-content:space-around ;
    padding:  0 1rem;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 0;
}
.rightSide{
    width: 50%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: right;
}
.top-right-menu{
    width: 100%;
    display: flex;
    align-items: center;
}
.top-right-menu ul{
    width: 100%;
    margin: 0;
}
.top-right-menu ul li{
    display: inline-block;
    padding: 8px 15px;
    font-size: 14px;
    border-radius: 5px;
    margin: 0 5px;
    cursor: pointer;
    font-weight: 500;
}
.top-right-menu ul .first-item{
    background-color:#fce35c ;
    color: #1d3041;
}
.top-right-menu ul .second-item{
    background-color:#fc3441 ;
    color: #fff;   
}
.top-right-menu ul .third-item{
    background-color:#024460 ;
    color: #fff;   
}
.top-right-menu ul .four-item{
    background-color:#4d8ff7 ;
    color: #fff;   
}
.leftSide{
    display: flex;
    align-items: center;
    justify-content: left;
    position: relative;
    width: 50%;
}
.left-section{
    width: fit-content;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
/* .leftSide .addNewBtn{
    margin-left: 1rem;
} */
.leftSide .addNewBtn button , .leftSide .productionList button ,
.leftSide .new-order-btn button{
    border: 0;
    padding: 5px 20px;
    /* height: 40px; */
    border-radius: 5px;
    background-color: #76E6B6;
    color: #014342;
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    line-height: 30px;
    border: 2px solid transparent;
}
.leftSide .productionList button{
    background-color: #dadada;
    color: #141c29;
}
.leftSide .my-account-btn .account-btn{
    width: 200px;
    background-color: #fff;
    color: #141c29;
    border: 2px solid #e0e0e0;
    padding: 5px ;
    border-radius: 5px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: right;
    font-size: 14px;
}
.leftSide .my-account-btn .account-btn img{
    border-radius: 5px;
}
.leftSide .my-account-btn .account-btn p{
    margin-right: 0.7rem;
    line-height: 1;
    display: inline-block;
}
.leftSide .my-account-btn .account-btn
.leftSide .addNewBtn button:hover{
    background-color: #2d896d;
}
.leftSide .profile{
    /* display: flex; */
        display: none;

    align-items: center;
    padding: 8px 10px;
    border-radius: 5px;
    cursor: pointer;
    border: 2px solid #e0e0e0;
}
.leftSide .profile:hover{
    background-color: #fff;
}
.leftSide .profile p{
    display: inline-block;
    padding: 0 0.5rem;
    font-weight: 500;
    font-size: 13px;
    color: #707070;
    margin: 0;
    font-family: 'Noto Sans Hebrew';
    font-weight: 600;
}
.leftSide .profile span{
    font-size: 20px;
    background-color: #e0e0e0;
    border-radius: 8px;
}
.leftSide .profile img{
    width: 25px;
    height: 25px;
    border-radius: 50%;
    display: inline-block;
}
.profileDropdown,
.NewDropDown{
    width: 200px;
    border-radius: 8px;
    position: absolute;
    position: absolute;
    left: 1rem;
    top: 4rem;
    background-color: #fff;
    padding: 0;
    box-shadow:rgba(116, 116, 116, 0.16) 0px 1px 4px;
    z-index: 999;
}
.NewDropDown{
    border: 1px solid #e0e0e0;
}
.profileDropdown ul
, .NewDropDown ul{
    width: 100%;
    margin: 0;
    padding: 0.3rem ;
}
.profileDropdown ul li ,
.NewDropDown ul li{
    list-style: none;
    font-size: 13px;
    color: #707070;
    padding: 10px ;
    display: flex;
    align-items: center;
    font-family: "Noto Sans Hebrew", sans-serif;
    font-weight: 500;
    margin: 0;
    cursor:pointer;
    border-radius: 8px;
}
.profileDropdown ul li i ,
.NewDropDown ul li i{
    font-size: 15px;
    margin-left: 5px;
}
.profileDropdown ul li:hover ,
.NewDropDown ul li:hover{
    background-color: #f3f4f6;
    color: #1c1c1c;
    transition: 0.3s ease-in-out;
}
.profileDropdown ul .logoutBtn{
    color: #d11a2a;
}
.paths{
    width: 100%;
    margin: 2rem 0;
    padding: 0rem 1rem ;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: left;
    display: none;
}
.paths .link{
    width: 150px;
    height: 37px;
    background-color: #baf3e6;
    color: #004d5a;
    font-weight: 600;
    border: 1px solid #baf3e6 ;
    border-radius: 8px;
    cursor: pointer;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-decoration: none;
}
.paths .link:hover{
    background-color: #76E8CD;
    border: 0;
    color: #004d5a;
}
.hide{
    display: none;
}
.show{
    display: block;
    transition: 0.5s;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
header {
  margin: 0;
  height: 70px;
  background-color: #1c1c1c;
  color: #ffffff;
  position: relative;
}
.button{
    text-decoration: none;
    background: none;
  border: 0;
}

.mobile-bottom-nav{
    display: none;
}
/* @media only screen and (max-width:1180px){
    .main{
        margin-right:150px;
        flex: 1 1 0;
    }
} */
.hideMenu{
    display: none;
}
.menuCover{
    display: none;

}
@media screen and (max-width:1180px){
    .main{
    margin-right: 200px; 
}
}
@media screen and (max-width:1180px) {
    *{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  direction: rtl;
  
}
.paths{
    display: none;
}
.rightSide{
    width: 20%;
}
.leftSide{
    width: 80%;
}
.sideBar{
    border: 0;
    margin-bottom: 0;
        background-color:#014342 ;

}
    .main{
        margin-right:0;
        flex: 1 1 0;
    }
    .mobile-bottom-nav{
	position:fixed;
	bottom:0;
	left:0;
	right:0;
	z-index:1000;
	transform: translateZ(0);
	height:77px;
    box-shadow: 0 -2px 5px -2px #33333330;
    display: block;
}
.top-right-menu{
    display: none;
}
.menu{
    width:100%;
    display: flex;
    align-items: center;
}
.menu i {
    font-size: 30px;
    color: #76E6B6;
}
.hideMenu{
    width: 0;
    transition: 0.5s;
    overflow: hidden;
    min-height: 100vh;
    background: #fafafa;
    position: fixed;
    z-index: 8888888;
    right: 0;
    top: 0;
    bottom: 0;
    display: block;
}
.menuCover{
    display: block;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100%;
    min-height: 100vh;
    position: fixed;
    z-index: 8888888;
    right: 0;
    top: 0;
    bottom: 0;
    transition: 0.3s;

}
.closeMenu-btn{
    width: 100%;
    display: flex;
    justify-content: center;
    height: 70px;
}
.menuOpened{
    width: 100%;
    max-width: 90%;
    min-height: 100vh;
    background: #fafafa;
    transition: 0.5s;
}
.closeMenu-btn .menuLogo{
    width: 90%;
    padding:  1rem 0;
    background-color: #fafafa;
    display: flex;
    align-items: center;
    justify-content: left;
}
.menuLogo span{
    font-size: 18px;
    display: flex;
    align-items: center;
}
.menuLogo span i {
    font-size: 24px;
}
.menuOpened .userProfile{
    width: 100%;
    padding:  0;
    background-color: #fafafa;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}
.userProfile .box{
    width: 90%;
    padding: 1rem;
    min-height: 90px;
    background-color: #e3eef7;
    border-radius: 15px;
    display: flex;
    position: relative;
}
.userProfile .box .item{
    width: fit-content;
}
.userProfile .box .item img{
    border-radius: 15px;
    width:70px ;
}
.userProfile .box .itemName{
    padding: 0.5rem 1rem;
    font-size: 14px;

}
.userProfile .box .itemName .firstText{
    font-size: 15px;
    font-weight: 700;
    margin: 0;
}
.userProfile .box .itemName .secText{
    color: #666;
    
}
.userProfile .box .itemIcon{
    position: absolute;
    left: 1rem;
    top: 2rem;
}
.sidebarMenu{
    width: 100%;
    /* padding:  1rem; */
    background-color: #fafafa;
    display: flex;
    justify-content: center;

}
.menuItems{
    width: 90%;
}
.menuItems ul{
    width: 100%;
    padding: 0;
}
.menuItems ul li {
    list-style: none;
    padding:  0 ;
    font-size: 14px;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    margin: 0;
}
.menuItems ul li .list-icon i{
    color: #222222;
    font-size: 20px;
}
.menuItems ul li .menuText{
    color: #777;
    margin-right: 0.5rem;
    font-family: 'Noto Sans Hebrew';
}
.menuItems ul li .mobile-menu-item{
    display: flex;
    align-items: center;
    width: 100%;
    border: 0;
    padding: 0.5rem 0;
    margin: 0;
    align-items: inherit;
    background-color: transparent;
    text-decoration: none;
}
.menuLine{
    width: 100%;
    height: 56px;
    display:flex;	
    background-color: #fff;
    justify-content: center;
    align-items: center;
}
.iphoneLine{
    width: 100%;
    height: 21px;
    background-color: #fff;
}
.menuItem{
    width: calc(100% / 5);
    text-align: center;
}
.menuItem i{
    display: block;
    color: #666;
    font-size: 20px;
}
.menuItem span{
    display: block;
    color: #666;
    font-size: 12px;
    font-family: 'Noto Sans Hebrew';
}
.menuItem .addBox i ,
.menuItem .addBox span{
    color: #4a7dff;
}
}

</style>



// WEBPACK FOOTER //
// src/App.vue